import { render } from "./DeleteUserForm.vue?vue&type=template&id=904f3e42"
import script from "./DeleteUserForm.vue?vue&type=script&lang=js"
export * from "./DeleteUserForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__